export default __webpack_public_path__ + "static/media/automate-duties.6c2c8406.svg";